import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'op-attribute',
  templateUrl: './attribute.component.html'
})
export class AttributeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
